import _ from "lodash";
import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  Typography,
} from "@mui/material";
import { Form, Formik, FormikValues } from "formik";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  EC_SUBMISSION_TYPES,
  RoutingList,
} from "../../../../constants";
import { useCreateEcsMutation } from "../../../../generated/graphql";
import { formikMultiStepHandler } from "../../../../utils/formikMultiStepFormStepHandler";
import { logger } from "../../../../utils/logger";
import CreatePageFormFooter from "../../../common/Form/CreatePageFormFooter/CreatePageFormFooter";
import ProgressSteps from "../../../common/ProgressSteps/ProgressSteps";
import ECSubmissionECN from "../ECSubmission/ECSubmissionECN";
import StudyDetails from "../StudyDetails/StudyDetails";
import {
  ECNotificationInitData,
  IRBSubmissionValidationSchema,
} from "../utils";
import { DocumentSubmissionDropdown } from "../../../../types/forms/DoumentSubmission";

type IRProps = {
  value: any;
};

export const ecNotificationStepsInfo = ["1. Study Details", "2. EC Notification"];

const ECNotification = (props: IRProps) => {
  const { value } = props;
  const [currentStep, setCurrentStep] = useState(0);
  const navigate = useNavigate();
  const [createEcsMutation] = useCreateEcsMutation();
  const saveHandler = async (values: FormikValues) => {
    try {
      await createEcsMutation({
        variables: {
          department: values.department,
          emails: values.emails,
          isFunded: values.isFunded,
          fundType: values.fundType,
          micr: values.micr,
          principalInvestigator: values.principalInvestigator,
          coInvestigator: values.coInvestigator,
          protocolNumber: values.protocolNumber,
          sponsor: values.sponsor,
          studyPhase: values.studyPhase,
          title: values.title,
          typeOfStudy: values.typeOfStudy,
          documents: values.documents
            .filter((doc: DocumentSubmissionDropdown) => doc.url !== "")
            .map((doc: DocumentSubmissionDropdown ) => ({
              label: doc.dropdownSelectedValue ? doc.label + '(' + doc.dropdownSelectedValue + ')' : doc.label,
              url: doc.url,
              remark: doc.remark,
              // dropdownSelectedValue: doc.dropdownSelectedValue|| ''
            })),
          type: EC_SUBMISSION_TYPES.EC_NOTIFICATION,
        },
      });
      toast.success("EC notification created successfully!");
      navigate(RoutingList.ethics_committee.index.path);
    } catch (err) {
      toast.error(
        (err as { message: string })?.message || "Something went wrong"
      );
      logger.error(err);
    }
  };

  return (
    <Formik
      initialValues={_.cloneDeep(ECNotificationInitData)}
      validationSchema={IRBSubmissionValidationSchema[currentStep]}
      onSubmit={(values, { setSubmitting, setErrors, validateForm }) => {
        formikMultiStepHandler({
          validateForm,
          values,
          stepIndex:
            currentStep > ecNotificationStepsInfo.length - 1 ? currentStep : currentStep + 1,
          setErrors,
          steps: currentStep,
          stepsInfo: ecNotificationStepsInfo,
          setSteps: setCurrentStep,
          saveHandler,
        });
      }}
    >
      <Form>
        <Card>
          <CardContent className="pd-x-30 pd-y-30">
            <Box className="mg-b-40">
              <Typography className="mg-b-10" variant="h2" component="h2">
                EC Notification
              </Typography>
              <ProgressSteps stepsInfo={ecNotificationStepsInfo} currentStep={currentStep} />
            </Box>
            <Grid container className="justify-content-center">
              <Grid item xs={12} md={10} lg={10}>
                {currentStep === 0 && <StudyDetails value={value} />}
                {currentStep === 1 && <ECSubmissionECN />}
                <CreatePageFormFooter
                  setSteps={setCurrentStep}
                  steps={currentStep}
                  stepsInfo={ecNotificationStepsInfo}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Form>
    </Formik>
  );
};

export default ECNotification;
